import {
  SIMILAR_ITEMS_INITIALISATION_FAILURE,
  LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS,
  RESET_INITIALISATION_SIMILAR_ITEMS,
  RECEIVE_SEE_SIMILAR_PRODUCT_ID,
  RECEIVE_SIMILAR_ITEMS
} from "../constants";

import { SET_ITEM_SAVED_STATUS } from "../../common/constants";

import {
  initialisationFailure,
  loadingDataOnPageLoad,
  resetInitialisation,
  receiveProductId,
  receiveItems,
  setItemSavedStatus
} from "./payloadCreators";

export default {
  [LOADING_DATA_ON_PAGE_LOAD_SIMILAR_ITEMS]: loadingDataOnPageLoad,
  [RESET_INITIALISATION_SIMILAR_ITEMS]: resetInitialisation,
  [RECEIVE_SEE_SIMILAR_PRODUCT_ID]: receiveProductId,
  [RECEIVE_SIMILAR_ITEMS]: receiveItems,
  [SIMILAR_ITEMS_INITIALISATION_FAILURE]: initialisationFailure,
  [SET_ITEM_SAVED_STATUS]: setItemSavedStatus
};
